import type { GameInfo } from '@/types/games';

export const GAMES_CATALOG: GameInfo[] = [
  {
    id: 'puzzle-corps-humain',
    name: 'Puzzle du Corps Humain',
    description: 'Place les organes au bon endroit sur la silhouette humaine. Apprends l\'anatomie en t\'amusant avec ce puzzle interactif !',
    category: ['Anatomie', 'Enfants'],
    difficulty: 'Moyen',
    durationMinutes: 10,
    imageUrl: 'https://ddfascfiaucteirbzkzd.supabase.co/storage/v1/object/public/assets/games/jeu-corps-humain.webp',
    path: '/jeux/puzzle-corps-humain',
    maxScore: 1000,
  },
  {
    id: 'memory',
    name: 'Memory Medical',
    description: 'Retrouve les paires d\'illustrations medicales et decouvre des anecdotes sante a chaque paire trouvee !',
    category: ['Memoire', 'Medecine', 'Enfants'],
    difficulty: 'Facile',
    durationMinutes: 5,
    imageUrl: 'https://ddfascfiaucteirbzkzd.supabase.co/storage/v1/object/public/assets/games/jeu-memory.webp',
    path: '/jeux/memory',
    maxScore: 500,
  },
  {
    id: 'quiz-sante',
    name: 'Quiz Sante',
    description: 'Teste tes connaissances en sante avec des questions interactives sur l\'hygiene, la nutrition, l\'anatomie et bien plus !',
    category: ['Medecine', 'Prevention', 'Hygiene', 'Nutrition'],
    difficulty: 'Moyen',
    durationMinutes: 8,
    imageUrl: 'https://ddfascfiaucteirbzkzd.supabase.co/storage/v1/object/public/assets/games/jeu-quiz.webp',
    path: '/jeux/quiz-sante',
    maxScore: 2000,
  },
  {
    id: 'puzzle-classique',
    name: 'Puzzle Classique',
    description: 'Reconstitue des illustrations medicales en puzzle. Choisis ton niveau de difficulte parmi 9, 16, 25 ou 49 pieces !',
    category: ['Logique', 'Medecine'],
    difficulty: 'Moyen',
    durationMinutes: 15,
    imageUrl: 'https://ddfascfiaucteirbzkzd.supabase.co/storage/v1/object/public/assets/games/jeu-puzzle.webp',
    path: '/jeux/puzzle-classique',
    maxScore: 1500,
  },
  {
    id: 'tic-tac-toe',
    name: 'Tic-Tac-Toe Sante',
    description: 'Affronte les virus et microbes dans ce morpion revisite ! Medecin contre Virus, qui gagnera la partie ?',
    category: ['Logique', 'Prevention', 'Enfants'],
    difficulty: 'Facile',
    durationMinutes: 3,
    imageUrl: 'https://ddfascfiaucteirbzkzd.supabase.co/storage/v1/object/public/assets/games/jeu-tictactoe.webp',
    path: '/jeux/tic-tac-toe',
    maxScore: 300,
  },
  {
    id: 'snake',
    name: 'Snake Nutrition',
    description: 'Guide le serpent pour collecter fruits et legumes tout en evitant la malbouffe et les virus. Apprends les bases de la nutrition !',
    category: ['Nutrition', 'Hygiene', 'Enfants'],
    difficulty: 'Facile',
    durationMinutes: 5,
    imageUrl: 'https://ddfascfiaucteirbzkzd.supabase.co/storage/v1/object/public/assets/games/jeu-snake.webp',
    path: '/jeux/snake',
    maxScore: 500,
  },
  {
    id: '2048',
    name: '2048 Sante',
    description: 'Fusionne les elements de la sante : de la cellule au corps humain en passant par les tissus et les organes !',
    category: ['Logique', 'Anatomie'],
    difficulty: 'Moyen',
    durationMinutes: 10,
    imageUrl: 'https://ddfascfiaucteirbzkzd.supabase.co/storage/v1/object/public/assets/games/jeu-2048.webp',
    path: '/jeux/2048',
    maxScore: 2000,
  },
  {
    id: 'sudoku',
    name: 'Sudoku Medical',
    description: 'Le celebre jeu de logique avec un theme medical apaisant. Plusieurs niveaux de difficulte pour tous les ages.',
    category: ['Logique', 'Adultes'],
    difficulty: 'Difficile',
    durationMinutes: 15,
    imageUrl: 'https://ddfascfiaucteirbzkzd.supabase.co/storage/v1/object/public/assets/games/jeu-sudoku.webp',
    path: '/jeux/sudoku',
    maxScore: 1000,
  },
  {
    id: 'pendu',
    name: 'Pendu Medical',
    description: 'Devine les mots medicaux avant que le pendu ne soit complet ! En francais et en anglais, avec des definitions.',
    category: ['Medecine', 'Logique'],
    difficulty: 'Moyen',
    durationMinutes: 5,
    imageUrl: 'https://ddfascfiaucteirbzkzd.supabase.co/storage/v1/object/public/assets/games/jeu-pendu.webp',
    path: '/jeux/pendu',
    maxScore: 800,
  },
  {
    id: 'mots-croises',
    name: 'Mots Croises Sante',
    description: 'Resous des grilles de mots croises sur le theme de la sante. Plusieurs tailles et themes medicaux disponibles !',
    category: ['Medecine', 'Logique', 'Adultes'],
    difficulty: 'Difficile',
    durationMinutes: 20,
    imageUrl: 'https://ddfascfiaucteirbzkzd.supabase.co/storage/v1/object/public/assets/games/jeu-crossword.webp',
    path: '/jeux/mots-croises',
    maxScore: 1500,
  },
  {
    id: 'drag-drop',
    name: 'Trie et Classe',
    description: 'Fais glisser medicaments, instruments et aliments dans les bonnes categories. Un jeu educatif sur la classification medicale.',
    category: ['Medecine', 'Logique', 'Enfants'],
    difficulty: 'Facile',
    durationMinutes: 5,
    imageUrl: 'https://ddfascfiaucteirbzkzd.supabase.co/storage/v1/object/public/assets/games/jeu-dragdrop.webp',
    path: '/jeux/drag-drop',
    maxScore: 600,
  },
  {
    id: 'labyrinthe',
    name: 'Labyrinthe Sante',
    description: 'Aide l\'ambulance ou le medecin a trouver son chemin jusqu\'au patient. Plusieurs niveaux de difficulte !',
    category: ['Logique', 'Enfants'],
    difficulty: 'Facile',
    durationMinutes: 5,
    imageUrl: 'https://ddfascfiaucteirbzkzd.supabase.co/storage/v1/object/public/assets/games/jeu-labyrinthe.webp',
    path: '/jeux/labyrinthe',
    maxScore: 400,
  },
  {
    id: 'trouve-differences',
    name: 'Trouve les Differences',
    description: 'Compare deux images medicales et trouve toutes les differences. Plusieurs scenes : cabinet, hopital, pharmacie...',
    category: ['Memoire', 'Logique', 'Medecine'],
    difficulty: 'Moyen',
    durationMinutes: 8,
    imageUrl: 'https://ddfascfiaucteirbzkzd.supabase.co/storage/v1/object/public/assets/games/jeu-diff.webp',
    path: '/jeux/trouve-differences',
    maxScore: 750,
  },
];

export const GAME_CATEGORIES: string[] = [
  'Anatomie', 'Nutrition', 'Hygiène', 'Prévention', 'Médecine', 'Logique', 'Mémoire', 'Enfants', 'Adultes',
];

export const DIFFICULTY_OPTIONS: string[] = ['Facile', 'Moyen', 'Difficile'];

export const HEALTH_TIPS: string[] = [
  'Se laver les mains régulièrement avec du savon pendant au moins 20 secondes élimine 99% des germes.',
  'Boire 1,5 à 2 litres d\'eau par jour aide votre corps à éliminer les toxines et à rester hydraté.',
  'Dormir 7 à 8 heures par nuit renforce votre système immunitaire et améliore votre concentration.',
  'Le cœur bat environ 100 000 fois par jour, pompant 7 500 litres de sang dans tout le corps.',
  'Les vaccins sauvent 2 à 3 millions de vies chaque année dans le monde selon l\'OMS.',
  'En cas d\'urgence, appelez le 15 (SAMU) ou le 112 (numéro d\'urgence européen).',
  'Manger 5 fruits et légumes par jour réduit le risque de maladies cardiovasculaires.',
  'L\'activité physique régulière (30 minutes par jour) diminue le stress et renforce les os.',
  'Le cerveau humain contient environ 86 milliards de neurones interconnectés.',
  'La peau est le plus grand organe du corps humain, elle pèse environ 4 kg chez un adulte.',
  'Les antibiotiques sont inefficaces contre les virus comme le rhume ou la grippe.',
  'Le lavage des dents deux fois par jour prévient les caries et les maladies des gencives.',
  'Une bonne posture réduit les douleurs dorsales et améliore la respiration.',
  'Le stress chronique peut affaiblir le système immunitaire et augmenter le risque de maladies.',
  'La vitamine D, produite par l\'exposition au soleil, est essentielle pour des os solides.',
];